/* ITE — atribución de origen para leads WhatsApp en la TIENDA Shopify (sin API de Meta).
   Igual que el del sitio, con event-delegation (sirve para botones dinámicos del tema).
   Expone window.iteSrc = {canal, gclid, kw, camp} y agrega "Ref:" al mensaje de WhatsApp.
   Extra tienda: si el botón no trae mensaje, pone un saludo por defecto. Primer-toque 90 días. */
(function(){
  "use strict";
  var p; try { p = new URLSearchParams(location.search); } catch(e){ p = { get:function(){ return null; } }; }
  function ck(n){ var m = document.cookie.match('(?:^|; )' + n + '=([^;]+)'); return m ? decodeURIComponent(m[1]) : ''; }
  function setck(n,v){ if(!v) return; document.cookie = n + '=' + encodeURIComponent(v) + ';max-age=7776000;path=/;SameSite=Lax'; }

  var gclid = p.get('gclid') || p.get('wbraid') || p.get('gbraid') || ck('ite_gclid');
  if (gclid) setck('ite_gclid', gclid);
  var utmS = p.get('utm_source'), utmC = p.get('utm_campaign'), kw = p.get('utm_term') || ck('ite_kw');
  if (kw) setck('ite_kw', kw);
  if (utmC) setck('ite_camp', utmC);
  var ref = document.referrer || '';

  var canal = ck('ite_canal');
  if (!canal) {
    if (gclid)                                   canal = 'google-ads';
    else if (utmS)                               canal = utmS;
    else if (/google\./i.test(ref))              canal = 'google-organico';
    else if (/bing\.|yahoo\.|duckduckgo/i.test(ref)) canal = 'buscador-organico';
    else if (/facebook|instagram|linkedin|t\.co|youtube/i.test(ref)) canal = 'social';
    else if (ref && ref.indexOf(location.host) === -1) canal = 'referido';
    else                                         canal = 'directo';
    setck('ite_canal', canal);
  }
  if (gclid && canal !== 'google-ads') { canal = 'google-ads'; setck('ite_canal', canal); }

  window.iteSrc = { canal: canal || 'directo', gclid: gclid || '', kw: kw || '', camp: utmC || ck('ite_camp') || '' };

  var DEFAULT_MSG = 'Hola ITE, vengo de la tienda en línea y quiero una cotización.';

  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('a[href*="wa.me"],a[href*="api.whatsapp.com"]');
    if (!a) return;
    try {
      var u = new URL(a.getAttribute('href'), location.href);
      var t = u.searchParams.get('text') || '';
      if (t.indexOf('Ref:') === -1) {
        if (!t) t = DEFAULT_MSG;
        var parts = [ window.iteSrc.canal ];
        if (window.iteSrc.camp) parts.push(window.iteSrc.camp);
        if (window.iteSrc.kw)   parts.push('"' + window.iteSrc.kw + '"');
        u.searchParams.set('text', t + '\n\nRef: ' + parts.join(' · '));
        a.setAttribute('href', u.toString());
      }
    } catch(err){}
  }, true);
})();
